import { dayjsUTC } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { WarrantsFilesAccount } from "@/models/admin/warrantsFilesAccount/warrantsFilesAccount"
import {
  IWarrantsFilesAccount,
  WarrantsFilesAccountStatus,
  WarrantsFilesDcaType,
  WarrantsFilesType,
} from "@/models/admin/warrantsFilesAccount/warrantsFilesAccount.types"

/**
 * A single `warrants_files_account` row as returned by Hasura. Mirrors the
 * generated `Financials_Warrants_Files_Account` row; kept as a narrow type so
 * the parser only depends on the columns it actually reads. The `data` jsonb
 * column isn't fetched — it's not useful rendered in a grid.
 */
export type WarrantsFilesAccountRaw = {
  id: number
  account_number: string
  customer_name?: string | null
  dca_type: string
  file_type: string
  created_at: string
  deleted_at?: string | null
  job_id: number
  status: string
  error_message?: string | null
  retry_count: number
}

export const WarrantsFilesAccountParser: IParser<
  IWarrantsFilesAccount,
  WarrantsFilesAccountRaw
> = {
  toDomain(data) {
    try {
      // Hasura `timestamp` columns are naive UTC, so parse them as UTC and
      // convert to local time for display.
      return new WarrantsFilesAccount(
        data.id,
        data.account_number,
        data.customer_name ?? null,
        data.dca_type as WarrantsFilesDcaType,
        data.file_type as WarrantsFilesType,
        dayjsUTC(data.created_at),
        data.deleted_at ? dayjsUTC(data.deleted_at) : null,
        data.job_id,
        data.status as WarrantsFilesAccountStatus,
        data.error_message ?? null,
        data.retry_count,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
